<template>
  <div>
    <Banner />
    <div class="main-content">
      <!-- <el-row :gutter="20" class="row-content">
        <el-col :span="11">
          <div class="block-content ribbon-success">
            <div class="ribbon-box">报考流程</div>
            <img class="img-fluid" :src="imgIp + processUrl" alt="报考流程" srcset="">
          </div>
        </el-col>
        <el-col :span="1"><div class="gray-bg"></div></el-col>
        <el-col :span="11">
          <div class="block-content ribbon-danger">
            <div class="ribbon-box">报考须知</div>
            <div class="paragraph-content" v-html="examText"></div>
          </div>
        </el-col>
      </el-row> -->
      <div class="card-content" style="padding-bottom: 30px;">
        <div class="card-header">
          <span>报考流程</span>
        </div>
        <div class="process-content">
          <img class="img-fluid" :src="imgIp + processUrl" alt="报考流程" srcset="">
        </div>
        <div class="warn-content">
          <div class="warn-title">
            <img :src="require('@/assets/warning_icon.png')" alt="" srcset="" class="warn-icon">
            <div>报考须知：</div>
          </div>
          <div class="warn-paragraph" v-html="examText"></div>
        </div>
      </div>
      <div class="card-content">
        <div class="card-header">
          <span>正在招考</span>
        </div>
        <el-table
          :data="examData"
          style="width: 100%">
          <el-table-column label="报名时间">
            <template slot-scope="scope">
              {{ scope.row.signupBeginTime }} ~ {{ scope.row.signupEndTime }}
            </template>
          </el-table-column>
          <el-table-column label="报名项目">
            <template slot-scope="scope">
              <el-link type="primary" :href="'#/examDetail?id=' + scope.row.id" :underline="false">{{ scope.row.examName }}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="详情" align="left" width="200">
            <template slot-scope="scope">
              <el-button type="primary" size="small" plain @click="examDetail(scope.row.id)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="card-content" shadow="never">
        <div class="card-header">
          <span>考务问答</span>
          <el-button style="float: right; padding: 3px 0" type="text" @click="moreQues">查看更多</el-button>
        </div>
        <div class="list-content">
          <ul>
            <li v-for="(obj, index) in dataArr" :key="index" class="data-row">
              <div class="title-content">
                <!-- <span class="disc-tag">·</span> -->
                <span class="row-title" @click="toQuesDetail(obj.id)">{{ obj.title }}</span>
              </div>
              <span class="row-date">{{ obj.createTime }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { homeExam } from '@/api/exam'
import { openListData } from '@/api/ques'
import Banner from './layout/components/Banner'
import config from '@/utils/index'

export default {
  name: 'Index',
  data() {
    return {
      examData: [],
      dataArr: [],
      imgIp: config.imgIp,
      processUrl: this.$store.state.app.processPhoto,
      examText: this.$store.state.app.examText
    }
  },
  components: {
    Banner
  },
  mounted() {
    this.getExamList()
    this.getQuesList()
  },
  methods: {
    getExamList() {
      homeExam()
        .then(res => {
          if (res.code === 200) {
            this.examData = res.data
          }
        })
    },
    getQuesList() {
      openListData({
        page: 1,
        limit: 5
      })
        .then(res => {
          if (res.code === 200) {
            this.dataArr = res.data.list
          }
        })
    },
    examDetail(id) {
      this.$router.push('/examDetail?id=' + id)
    },
    toQuesDetail(id) {
      this.$router.push('ques/detail?id=' + id)
    },
    moreQues() {
      this.$router.push('/ques/list')
    }
  }
}
</script>

<style lang="scss" scoped>
.main-content {
  padding: 30px;
  max-width: 1200px;
  margin: 0 auto;
  .row-content {
    background: #fff;
    display: flex;
    justify-content: space-around;
    margin: 0 !important;
    .gray-bg {
      background: #f0f2f5;
      width: 100%;
      height: 100%;
    }
    .block-content {
      background: #fff;
      padding: 20px 20px 1px;
      overflow-x: visible;
      position: relative;
      min-height: 240px;
      .ribbon-box {
        position: absolute;
        top: 10px;
        left: 0;
        padding: 0 12px;
        height: 32px;
        line-height: 32px;
        color: #fff;
        font-weight: 600;
        z-index: 2;
        &::before {
          position: absolute;
          display: block;
          width: 0;
          content: '';
          height: 0;
          top: 0;
          left: 100%;
          right: auto;
          border: 16px solid;
          border-left-width: 0;
          border-right-width: 8px;
        }
      }
    }
    .ribbon-success {
      .ribbon-box {
        background-color: #9ccc65;
        &::before {
          border-color: #9ccc65;
          border-right-color: transparent;
        }
      }
    }
    .ribbon-danger {
      .ribbon-box {
        background-color: #ef5350;
        &::before {
          border-color: #ef5350;
          border-right-color: transparent;
        }
      }
    }
  }
  .card-content {
    margin-top: 24px;
    padding: 0 24px;
    background: #fff;
    border-radius: 4px;
    .card-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 24px 8px;
      font-size: 16px;
      color: #333;
      font-weight: bold;
    }
  }
  .list-content {
    .data-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 28px;
      font-size: 14px;
      list-style-type: disc;
      padding: 17px 8px;
      border-top: 1px solid #f0f0f0;
      .title-content {
        display: flex;
        align-items: center;
      }
      .disc-tag {
        color: #3888ff;
        font-size: 40px;
        margin-right: 6px;
      }
      .row-title {
        color: #333;
        flex: 1;
        justify-content: start;
        cursor: pointer;
      }
      .row-date {
        flex-grow: 0;
        color: #606266;
      }
      .status-tag {
        margin-left: 10px;
      }
    }
  }
}
.process-content {
  width: 100%;
  .img-fluid {
    width: 100%;
    height: auto;
  }
}
.warn-content {
  border: 1px solid #EC4E3D;
  margin-top: 35px;
  border-radius: 4px;
  padding: 13px 20px;
  display: flex;
  .warn-title {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    height: 20px;
    color: #EC4E3D;
    font-size: 16px;
    .warn-icon {
      margin-right: 5px;
      height: 18px;
    }
  }
  .warn-paragraph {
    color: #575757;
    line-height: 22px;
    font-size: 14px;
    text-align: left;
  }
}
</style>
